import { Redirect } from 'react-router-dom'
import { INodeChildren } from '../../../types/shared/GeneralTypes'
import { getToken } from '../../utils/apiClient'
import useUpdateFeatureFlagAbility from './useUpdateFeatureFlagAbility'
import useGetCurrentUser from './useGetCurrentUser'
import CoreLoading from '../../components/CoreLoading'
import useSetDefaultLanguage from '../../hooks/useSetDefaultLanguage'
import useOnboardingCheck from '../../hooks/useOnboardingCheck'

const AuthMiddleware: React.FC<INodeChildren> = ({ children }) => {
  const token = getToken()
  useSetDefaultLanguage()
  const { isLoadingFeatureFlags } = useUpdateFeatureFlagAbility()
  useGetCurrentUser()
  useOnboardingCheck()
  useSetDefaultLanguage()

  if (!token) {
    return <Redirect to={`/login?redirect=${window.location.pathname}`} />
  }

  if (isLoadingFeatureFlags) return <CoreLoading />

  return <div>{children}</div>
}

export default AuthMiddleware
